var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from 'styled-components';
import { grey } from '@platform/front-ui';
export var viewOnlyLabel = function () {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        color: ", ";\n        font-size: 14px;\n        font-weight: 700;\n    "], ["\n        color: ", ";\n        font-size: 14px;\n        font-weight: 700;\n    "])), grey[900]).join('');
};
var templateObject_1;
